import React, { Component } from 'react';
import {
    Container, Grid, Segment, Header, Table, Label, Button, Image, List, Icon
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
    getClaimOptions,
    updateInpatientClaim,
    updateUnsubmittedInpatientClaim
} from '../../actions';
import FormsUpdateClaimInpatient from '../../component/forms/claim/inpatient/update';

class ClaimUpdateInpPage extends Component {
    // componentDidMount() {
    //     this.props.getClaimOptions(this.props.user.accessToken);
    // }
    render() {
        const claimTransactionNo = this.props.match.params.claimTransactionNo;
        // const selectedInpatientClaim = _.find(this.props.inpatientClaims, (claim) => claim.transactionNo === claimTransactionNo);
        const selectedInpatientClaim = this.props.viewedClaims[claimTransactionNo];
        // console.log(selectedInpatientClaim);
        return (
            <Container fluid>
                <Segment attached="top">
                    <Header>Update Claim - {claimTransactionNo}</Header>
                </Segment>
                <Link to={`/app/claimrecords/inp/${claimTransactionNo}/${selectedInpatientClaim.status}`}>
                    <Button attached>
                        <Icon name="user cancel" />
                        Cancel Update - Go back to view this claim
                    </Button>
                </Link>
                <Segment attached>
                    <Grid>
                        <Grid.Column>
                            <FormsUpdateClaimInpatient
                                updateInpatientClaim={this.props.updateInpatientClaim}
                                claimTransactionNo = {claimTransactionNo}
                                updateUnsubmittedInpatientClaim={this.props.updateUnsubmittedInpatientClaim}
                                user={this.props.user}
                                claimAttachment={this.props.claimAttachment}
                                claimOptions={(this.props.claimOptions) ? this.props.claimOptions.inpatientClaimOptions : {}}
                                currentClaimData={selectedInpatientClaim}
                                configBenefit={this.props.configBenefit}
                                appLaunchConfig={this.props.appLaunchConfig}
                                claimFilterOptions={this.props.claimFilterOptions}
                            />
                        </Grid.Column>
                    </Grid>
                </Segment>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user.user,
        claimOptions: state.claimOptions,
        inpatientClaims: state.claims.inpatientClaims,
        claimAttachment: state.claims.claimImage,
        viewedClaims: state.claims.viewed,
        configBenefit: state.user.configBenefit,
        appLaunchConfig: state.appLaunchConfig,
        claimFilterOptions: state.claims.filterOptions,
    };
}

export default connect(mapStateToProps, {getClaimOptions, updateInpatientClaim, updateUnsubmittedInpatientClaim})(ClaimUpdateInpPage);
